import React from "react";
import LogoImg from "../../assets/img/new-logo.png";

function GlobalLogo({logoClass}) {
  return (
    <div className={logoClass}>
      <img src={LogoImg} alt="surya-logo" />
    </div>
  );
}

export default GlobalLogo;
